import { Component } from 'vue';
import Modal from '@/general/utils/Modal';
import DriveBookingContext from '../models/DriveBookingContext';

const CancelReservationModal = (): Component => import('../modals/CancelReservationModal.vue');
const CancelChangeModal = (): Component => import('../modals/CancelChangeModal.vue');

class DriveBookingModals {
  cancelReservation(driveBookingId: number, driveContext: DriveBookingContext) {
    return Modal.openAndWait(CancelReservationModal, { driveBookingId, driveContext });
  }

  cancelChange(title: string, message: string) {
    return Modal.openAndWait(CancelChangeModal, { title, message });
  }
}
export default new DriveBookingModals();